import React, { useEffect } from 'react';

import { Navigate, useLocation } from 'react-router-dom';

import Auth from '..';

import { useAuth } from '~/context/AuthContext';

const DEFAULT_ROUTE = '/';

const AuthWrapper: React.FC = () => {
  const { isAuthenticated, isLoadingGoogle, isLoadingUser } = useAuth();
  const location = useLocation();

  // Get the stored location from state, or default to home
  const from = location.state?.from?.pathname || DEFAULT_ROUTE;

  // Store the original path in sessionStorage for auth functions to use
  useEffect(() => {
    if (location.state?.from?.pathname) {
      const fullPath = location.state.from.pathname + (location.state.from.search || '');
      sessionStorage.setItem('auth_redirect_path', fullPath);
    } else if (!sessionStorage.getItem('auth_redirect_path')) {
      // If no redirect path is stored and no original location, default to home
      sessionStorage.setItem('auth_redirect_path', DEFAULT_ROUTE);
    }
  }, [location.state]);

  // Show loading indicator while checking authentication
  if (isLoadingGoogle || isLoadingUser) {
    return <div className="flex min-h-screen items-center justify-center">Loading...</div>;
  }

  // If user is authenticated, redirect to the stored location
  if (isAuthenticated) {
    return <Navigate to={from} replace />;
  }

  // Otherwise, show the Auth component
  return <Auth />;
};

export default AuthWrapper;
